import React from 'react';

const arrowColor = '#545cd8';

export const ArrowDown = () => {
    return (
        <span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style={{
                    height: '22px',
                    width: '16px',
                    color: arrowColor,
                    fill: arrowColor,
                }}>
                <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="48"
                    d="M112 184l144 144 144-144"
                />
            </svg>
        </span>
    );
};
